import React, { useRef } from 'react';
import Editor from './Editor';

export default function QuillTextEditor({ readOnly, value, onChange, height = '200px', placeholder = 'Enter description...', className = '' }) {
  const quillRef = useRef();
  return (
    <>
      <div className={`bg-white p-0 ${className} ${readOnly ? 'readonly' : ''}`}>
        <Editor
          height={height}
          ref={quillRef}
          readOnly={readOnly}
          placeholder={placeholder}
          defaultValue={value}
          onTextChange={(delta, oldDelta, source, editor) => onChange(editor?.root?.innerHTML)}
        />
      </div>
    </>
  );
}
